import { useState, useCallback } from 'react';
import axios from 'axios';

const useProcurementRequests = (type) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchProcurementRequests = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.get(`/api/RfqHeader/get-rfq-by-user`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const data = response.data || [];

      const enriched = data.map((rfq) => {
        const projectSubsidiaryMaps = rfq.rfqProjectSubsidiary?.projectSubsidiaryMap ?? [];

        const projectSubsidiaryNameList = projectSubsidiaryMaps.map((ps) => {
          const project = rfq.projects?.find((p) => p.projectId === ps.projectId);
          const projectName = project?.name ?? 'Unknown Project';
          const subsidiaryName = ps.subsidiaryName ?? 'Unknown Subsidiary';
          return `${projectName} / ${subsidiaryName}`;
        });

        return {
          ...rfq,
          projectSubsidiaryNameList,
        };
      });

      const open = enriched.filter(
        (item) =>
          item.formStatus === false &&
          item.readyForApproval === false &&
          item.rfqType == type &&
          item.isDeleted === false
      );
      const awaitingApproval = enriched.filter(
        (item) =>
          item.formStatus === false &&
          item.readyForApproval === true &&
          item.rfqType == type &&
          item.isDeleted === false
      );
      const closed = enriched.filter(
        (item) => item.formStatus === true && item.rfqType == type && item.isDeleted === false
      );
      const archived = enriched.filter((item) => item.rfqType == type && item.isDeleted === true);

      return { open, awaitingApproval, closed, archived };
    } catch (err) {
      setError(err.message || 'An error occurred');
      console.error(`Error fetching ${type}'s:`, err);
      return { open: [], awaitingApproval: [], closed: [], archived: [] };
    } finally {
      setLoading(false);
    }
  }, [type]);

  return { fetchProcurementRequests, loading, error };
};

export default useProcurementRequests;
